import React from 'react';

export default function Captcha({store, onChange, value}) {
  const [code, setCode] = React.useState('');

  function generateCode() {
    const generated = [1, 2, 3, 4].map(() => Math.floor(Math.random() * 10)).join('');
    store.captcha = generated;
    return generated;
  }

  function changeCode(e) {
    if(e) e.preventDefault();
    const generatedCode = generateCode();
    setCode(generatedCode);

    // insert to canvas
    addCode(generatedCode);
  }

  React.useEffect(() => {
    changeCode();
  }, [])

  function addCode(newCode) {
    const canvas = document.getElementById('captcha');
    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;

    // Temizle ve Arka Plan Gürültüsü (Rakamlardan önce)
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = "#f0f0f0"; // Hafif gri arka plan botları şaşırtır
    ctx.fillRect(0, 0, w, h);

    // Her karakteri ayrı ayrı işle
    ctx.font = "bold 36px serif";
    ctx.textBaseline = "middle";

    for (let i = 0; i < newCode.length; i++) {
      const char = newCode[i];
      const x = 20 + (i * 40); // Karakterler arası mesafe
      const y = h / 2 + (Math.random() * 10 - 5); // Rastgele dikey kayma

      ctx.save();
      ctx.translate(x, y);

      // 1. Rastgele Döndürme (Rotation)
      const angle = (Math.random() * 0.4) - 0.2; // -0.2 ile 0.2 radyan arası
      ctx.rotate(angle);

      // 2. Rastgele Renk Tonu (Opsiyonel)
      ctx.fillStyle = `rgb(${Math.random() * 150}, 0, 0)`; // Farklı kırmızı tonları

      ctx.fillText(char, 0, 0);
      ctx.restore();
    }

    // 3. Daha Yoğun Çizgiler ve Noktalar
    addLines(ctx, w, h);
    addNoise(ctx, w, h);
  }

  // Çizgileri biraz daha kalınlaştırabiliriz
  function addLines(ctx, w, h) {
    for(let i = 0; i < 6; i++) { // Çizgi sayısını artırdık
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.5 + 0.2})`;
      ctx.lineWidth = Math.random() * 2;
      ctx.beginPath();
      ctx.moveTo(Math.random() * w, Math.random() * h);
      ctx.lineTo(Math.random() * w, Math.random() * h);
      ctx.stroke();
    }
  }

  function addNoise(ctx, w, h) {
    for (let i = 0; i < 150; i++) { // Nokta sayısını artırdık
      ctx.fillStyle = "red";
      ctx.fillRect(Math.random() * w, Math.random() * h, 1.5, 1.5);
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20, marginBottom: 12}}>
      <div className="form-item" style={{ 'display': 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <label>
          Kod: 
        </label>
        <input
          required
          type="text"
          name="captcha"
          style={{
            padding: "0.8rem",
            borderRadius: "4px",
            width: "100%",
            outline: "none !important",
            fontSize: 16,
            border: "1px solid #ccc",
          }}
          value={value}
          onChange={(e) =>
            onChange(e.target.value)
          }
        />
      </div>
      <div style={{
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        gap: '10px' 
      }}>
        <div>
          <canvas id="captcha" width="200" height="50"></canvas>
        </div>
        <div>
          <button 
            className="button__clean" 
            style={{ padding: 0, height: 24, width: 24, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
            onClick={changeCode}>
            <svg width="16" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <g strokeWidth="0"></g>
              <g strokeLinecap="round" strokeLinejoin="round"></g>
              <g>
                <path d="M19.146 4.854l-1.489 1.489A8 8 0 1 0 12 20a8.094 8.094 0 0 0 7.371-4.886 1 1 0 1 0-1.842-.779A6.071 6.071 0 0 1 12 18a6 6 0 1 1 4.243-10.243l-1.39 1.39a.5.5 0 0 0 .354.854H19.5A.5.5 0 0 0 20 9.5V5.207a.5.5 0 0 0-.854-.353z"></path> 
              </g>
            </svg>
          </button>
        </div>
      </div>

    </div>
  )
}
